import React, { useState, useEffect } from 'react';
import apiProjects from '../../../api/projects';
import apiprojectsByProcessAreas from '../../../api/projectsByProcessAreas';
import MultiSelect from '../../layout/forms/MultiSelect';

const Projects = ({ selected, setSelected }) => {
    const [projects, setProjects] = useState([]);
  
    const fetchProjects = async () => {
        let result;
        if (selected.processAreas.length > 0) {
            result = await apiprojectsByProcessAreas.post(selected.processAreas.map(processArea => processArea.value));
            }
            else
            {
                result = await apiProjects.masterProjects.get();
            }
            setProjects(result.map(project => ({ label: project.name, value: project.masterProjectKEY })));
        }
        useEffect(() => {
            fetchProjects();
        }, [selected.processAreas]);   
    const setSelectedProjects = (projects) => setSelected({ ...selected, projects });
    return (
    <MultiSelect
        options={projects}
        value={selected.projects}
        onChange={setSelectedProjects}
        labelledBy="Projects"
        label="Project"
     />
    )
}
export default Projects

